<p-autoComplete name="accountNumber" class="autoComplete" field="accountNumber" [placeholder]="Validation.AutoCompletePlaceholder"
                [suggestions]="accountOptions" [minLength]="Validation.AutoCompleteMinLength" [showEmptyMessage]="true"
                (completeMethod)="searchAccount($event)"
                [(ngModel)]="selectedAccount" (onSelect)="onSelectAccount()" required>
  <ng-template let-acc pTemplate="item">
    <div *ngFor="let property of properties; let i = index">
      {{acc[property]}}
    </div>
  </ng-template>
</p-autoComplete>
